import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  text-align: center;
`;

export const Image = styled.img`
  width: 255px;
  height: 191px;
  margin-bottom: 20px;
`;

export const Title = styled(Typography.Header).attrs({ $variant: '2' })`
  margin-bottom: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-weight: 500;
`;

export const Subtitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
